/* eslint-disable babel/object-curly-spacing */
import convert from "convert";

const SIZE_CONVERSION_KEY = "user-size-conversion";

class SizeConverter extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
    this.formatter = new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 0,
    });
  }

  setElementData(element, { original, rounded }) {
    element.innerText = rounded;
    if (!element.dataset.original) {
      element.dataset.original = original;
    }
  }

  connectedCallback() {
    this.initializeElements();
    this.addEventListeners();
    this.getSelectionFromBrowser();
    this._initialized = true;
  }

  initializeElements() {
    this.buttons = this.querySelectorAll(".button--converter");
    this.selectedUnit = this.querySelector(".button--converter.is-active");
    this.sizeButtonContainer = this.closest(".product-form__option-selector");
    this.sizeLabels = this.sizeButtonContainer.querySelectorAll(
      ".block-swatch__item",
    );
  }

  addEventListeners() {
    this.buttons.forEach((button) => {
      button.addEventListener("click", (evt) => {
        this.convertLabels(evt.target, evt.target.dataset.unit);
      });
    });

    document.addEventListener("variant:changed", (evt) => {
      const variant = evt.detail.variant;
      const optionValueElement = this.sizeButtonContainer.querySelector(
        ".product-form__option-value",
      );
      this.setElementData(
        optionValueElement,
        this.convertLabel(variant.title, this.selectedUnit.dataset.unit),
      );
    });
  }

  convertLabel(label, unit) {
    const valueObject = this.splitDualMeasurement(label);
    if (!valueObject) {
      console.warn(`Invalid label format: ${label}`);
      return {
        original: label,
        rounded: label,
      };
    }

    const convertedX = convert(valueObject.sizeX, valueObject.unit).to(unit);
    const convertedY = convert(valueObject.sizeY, valueObject.unit).to(unit);

    const roundedX = this.formatter.format(convertedX);
    const roundedY = this.formatter.format(convertedY);

    return {
      original: `${convertedX}x${convertedY}${unit}`,
      rounded: `${roundedX}x${roundedY}${unit}`,
    };
  }

  convertLabels(button, unit) {
    this.sizeLabels.forEach((label) => {
      this.setElementData(
        label,
        this.convertLabel(label.dataset.original || label.innerText, unit),
      );
    });

    const optionValueElement = this.sizeButtonContainer.querySelector(
      ".product-form__option-value",
    );
    this.setElementData(
      optionValueElement,
      this.convertLabel(
        optionValueElement.dataset.original || optionValueElement.innerText,
        unit,
      ),
    );

    this.storeSelectionToBrowser(unit);
    this.toggleButtonState(button, unit);
  }

  storeSelectionToBrowser(unit) {
    localStorage.setItem(SIZE_CONVERSION_KEY, unit);
  }

  getSelectionFromBrowser() {
    const localUnit = localStorage.getItem(SIZE_CONVERSION_KEY);
    if (localUnit) {
      this.convertLabels(null, localUnit);
    }
  }

  toggleButtonState(target, unit) {
    this.buttons.forEach((button) => {
      button.classList.remove("is-active");
      if (button.getAttribute("data-unit") === unit) {
        button.classList.add("is-active");
        this.selectedUnit = button;
      }
    });
  }

  splitDualMeasurement(input) {
    const regex = /^(\d+\.?\d*)x(\d+\.?\d*)([a-zA-Z]+)$/;
    const match = input.match(regex);

    if (match) {
      return {
        sizeX: parseFloat(match[1]),
        sizeY: parseFloat(match[2]),
        unit: match[3],
      };
    }
    return null;
  }
}

customElements.define("size-converter", SizeConverter);

export default SizeConverter;
